/* Pale Meridian Overhaul V1: storefront behaviour. No animation libraries; motion is added in a later version. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- Product gallery: swipe/scroll slides, arrows, counter, thumbnail strip with arrows ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-pmo-track]');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.children);
    var prev = root.querySelector('[data-pmo-gallery-prev]');
    var next = root.querySelector('[data-pmo-gallery-next]');
    var counter = root.querySelector('[data-pmo-gallery-index]');
    var thumbsWrap = root.querySelector('[data-pmo-thumbs-wrap]');
    var thumbsTrack = root.querySelector('[data-pmo-thumbs]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pmo-thumb]'));
    var current = 0;

    function width() { return track.clientWidth || 1; }

    function goTo(i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      if (instant) {
        var prevBehaviour = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = i * width();
        track.style.scrollBehavior = prevBehaviour;
      } else {
        track.scrollTo({ left: i * width() });
      }
      setActive(i);
    }

    function setActive(i) {
      current = i;
      if (counter) counter.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      // keep the active thumbnail visible inside its strip without moving the page
      var t = thumbs[i];
      if (t && thumbsTrack) {
        var left = t.offsetLeft - thumbsTrack.offsetLeft;
        if (left < thumbsTrack.scrollLeft || left + t.offsetWidth > thumbsTrack.scrollLeft + thumbsTrack.clientWidth) {
          thumbsTrack.scrollTo({ left: left - (thumbsTrack.clientWidth - t.offsetWidth) / 2 });
        }
      }
    }

    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / width());
        if (i !== current) setActive(i);
      }, 60);
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10)); });
    });

    function updateThumbArrows() {
      if (!thumbsWrap || !thumbsTrack) return;
      thumbsWrap.classList.toggle('has-overflow', thumbsTrack.scrollWidth > thumbsTrack.clientWidth + 2);
    }
    if (thumbsWrap) {
      var tp = thumbsWrap.querySelector('[data-pmo-thumbs-prev]');
      var tn = thumbsWrap.querySelector('[data-pmo-thumbs-next]');
      var step = function () { return Math.max(thumbsTrack.clientWidth * 0.8, 100); };
      if (tp) tp.addEventListener('click', function () { thumbsTrack.scrollBy({ left: -step() }); });
      if (tn) tn.addEventListener('click', function () { thumbsTrack.scrollBy({ left: step() }); });
      updateThumbArrows();
      window.addEventListener('resize', updateThumbArrows);
    }
    window.addEventListener('resize', function () { goTo(current, true); });

    goTo(parseInt(root.getAttribute('data-start'), 10) || 0, true);

    return {
      showMedia: function (mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(mediaId)) { goTo(i); return; }
        }
      }
    };
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-pmo-variants]') || document.querySelector('[data-pmo-variants]');
    var idInput = root.querySelector('[data-pmo-variant-id]');
    var priceEl = root.querySelector('[data-pmo-price]');
    var stickyPriceEl = document.querySelector('[data-pmo-sticky-price]');
    var stickyMetaEl = document.querySelector('[data-pmo-sticky-meta]');
    var etaEls = document.querySelectorAll('[data-pmo-eta]');
    var buttons = document.querySelectorAll('[data-pmo-add]');
    var form = root.querySelector('[data-pmo-form]');
    var productEta = root.getAttribute('data-product-eta') || '';
    var etaFallback = root.getAttribute('data-eta-fallback') || '';
    var galleryEl = root.querySelector('[data-pmo-gallery]');
    var gallery = galleryEl ? initGallery(galleryEl) : null;

    // Quantity
    root.querySelectorAll('[data-pmo-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentNode.querySelector('input');
        var next = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-pmo-qty-step'), 10);
        input.value = Math.max(1, next);
      });
    });

    // Sticky bar: shows once the main add button scrolls above the viewport
    var sticky = document.querySelector('[data-pmo-sticky]');
    var mainBtn = root.querySelector('[data-pmo-add-main]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainBtn);
      var stickyBtn = sticky.querySelector('[data-pmo-add]');
      if (stickyBtn && form) {
        stickyBtn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      }
    }

    if (!dataEl || !idInput) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-pmo-option]'));
    var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];
    var selected = current.options.slice();
    var firstRender = true;

    function matches(v, opts) {
      return v.options.every(function (o, i) { return o === null || o === opts[i]; });
    }

    function render() {
      groups.forEach(function (g) {
        var idx = parseInt(g.getAttribute('data-pmo-option'), 10);
        var label = g.querySelector('[data-pmo-option-value]');
        if (label) label.textContent = selected[idx];
        g.querySelectorAll('[data-value]').forEach(function (chip) {
          var val = chip.getAttribute('data-value');
          chip.setAttribute('aria-pressed', val === selected[idx] ? 'true' : 'false');
          // mark values that cannot be bought with the other current choices
          var test = selected.slice(); test[idx] = val;
          var match = variants.filter(function (v) { return matches(v, test); })[0];
          chip.classList.toggle('is-unavailable', !match || !match.available);
        });
      });

      var v = variants.filter(function (x) { return matches(x, selected); })[0];
      buttons.forEach(function (b) {
        b.disabled = !v || !v.available;
        b.textContent = !v ? 'Unavailable' : (v.available ? 'Add to basket' : 'Sold out');
      });
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_html;
      if (stickyPriceEl) stickyPriceEl.textContent = v.price;
      if (stickyMetaEl) stickyMetaEl.textContent = (v.title === 'Default Title') ? '' : v.title;
      var eta = v.eta || productEta || etaFallback;
      etaEls.forEach(function (el) { el.textContent = eta; });
      if (!firstRender && gallery && v.media_id) gallery.showMedia(v.media_id);
      if (window.history && window.history.replaceState && v.id !== current.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      current = v;
      firstRender = false;
    }

    groups.forEach(function (g) {
      var idx = parseInt(g.getAttribute('data-pmo-option'), 10);
      g.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-value]');
        if (!chip) return;
        selected[idx] = chip.getAttribute('data-value');
        render();
      });
    });
    render();
  }

  /* ---------- Cart ---------- */
  function initCart(root) {
    var busy = false;
    function change(line, qty, el) {
      if (busy) return;
      busy = true;
      if (el) el.classList.add('is-busy');
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { busy = false; if (el) el.classList.remove('is-busy'); });
    }
    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-pmo-cart-step]');
      var rm = e.target.closest('[data-pmo-cart-remove]');
      var lineEl = e.target.closest('[data-line]');
      if (!lineEl) return;
      var line = parseInt(lineEl.getAttribute('data-line'), 10);
      if (step) {
        var input = lineEl.querySelector('input');
        var next = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-pmo-cart-step'), 10);
        change(line, Math.max(0, next), lineEl);
      } else if (rm) {
        change(line, 0, lineEl);
      }
    });
    root.addEventListener('change', function (e) {
      var input = e.target.closest('input[data-pmo-cart-qty]');
      if (!input) return;
      var lineEl = input.closest('[data-line]');
      var v = parseInt(input.value, 10);
      change(parseInt(lineEl.getAttribute('data-line'), 10), isNaN(v) || v < 0 ? 1 : v, lineEl);
    });
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    document.querySelectorAll('[data-pmo-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Mobile menu drawer ---------- */
  function initMenu() {
    var menu = document.querySelector('[data-pmo-menu]');
    if (!menu) return;
    function lock(on) {
      document.documentElement.style.overflow = on ? 'hidden' : '';
    }
    menu.addEventListener('toggle', function () { lock(menu.open); });
    menu.querySelectorAll('[data-pmo-menu-close]').forEach(function (el) {
      el.addEventListener('click', function () { menu.open = false; });
    });
    menu.querySelectorAll('.pmo-drawer a').forEach(function (a) {
      a.addEventListener('click', function () { menu.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
    });
    window.addEventListener('resize', function () {
      if (menu.open && window.matchMedia('(min-width: 1000px)').matches) menu.open = false;
    });
  }

  ready(function () {
    document.querySelectorAll('[data-pmo-product]').forEach(initProduct);
    document.querySelectorAll('[data-pmo-cart]').forEach(initCart);
    initSort();
    initMenu();
  });
})();
